import { useState } from "react";
import Pagination from "../../../componentes/pagination/Pagination";

export function TabelaContasPagar({ dados }) {
    const [changeData, setChangeData] = useState([]);

    return (
        <>
            <div className="table-responsive overflow-y-auto fade-in" style={{ maxHeight: '80vh' }} >
                <table className="table text-sm text-left rtl:text-right text-muted-foreground">
                    <thead className="bg-table-header text-table-header-fg sticky top-0">
                        <tr>
                            {dados.length > 0 &&
                                Object.keys(dados[0]).map((col, idx) => (
                                    <th key={idx} className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">
                                        {col.replaceAll('_', ' ')}
                                    </th>
                                ))}
                        </tr>
                    </thead>
                    <tbody>
                        {changeData.map((item, idx) => (
                            <tr key={idx} className="table-items hover:bg-table-row-hover transition-colors">
                                {Object.values(item).map((val, colIdx) => (
                                    <td key={colIdx} className="px-4 py-3 whitespace-nowrap text-sm text-muted-foreground">
                                        {val !== null ? val.toString() : ""}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <Pagination
                data={dados}
                length={changeData.length}
                currentData={setChangeData}
            >
            </Pagination>
        </>
    );
}
